<template>
  <div v-if="showModal && isMobile" class="welcome-modal-overlay" :style="{ paddingTop: floatingBtnTop + 'px', paddingBottom: paddingBottom + 'px' }" @click.self="closeModal">
    <div class="welcome-modal" :style="{ maxHeight: maxModalHeight + 'px' }">
      <div class="modal-image-container">
        <img 
          :src="modalImage" 
          alt="Estudiantes en biblioteca"
          class="modal-image"
        />
        <div class="modal-image-overlay">
          <svg width="146" height="114" viewBox="0 0 146 114" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M89.1289 0V0.00488281C92.6428 0.00496984 96.0102 1.40322 98.4932 3.8916L142.123 47.6172C147.292 52.8027 147.292 61.207 142.123 66.3877L98.4932 110.113C96.0102 112.602 92.6428 114 89.1289 114H0V112.1H89.1289C92.1602 112.1 95.0119 110.914 97.1543 108.768L140.784 65.041C145.211 60.6044 145.211 53.3907 140.784 48.9541L97.1543 5.22852C95.0119 3.08141 92.1604 1.89559 89.1289 1.89551H0V0H89.1289Z" fill="white"/>
          </svg>
        </div>
      </div>
      
      <div class="modal-content">
        <h2 class="modal-title">¡Te damos la bienvenida a Bibliotecas AIEP! 👋</h2>
        <p class="modal-question">¿Quieres ver cómo funciona el sitio?</p>
        
        <div class="modal-buttons">
          <button class="btn-guide" @click="showGuide">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_40002161_2825)">
                <path d="M8 14.8571C4.21714 14.8571 1.14286 11.7829 1.14286 8C1.14286 4.21714 4.21714 1.14286 8 1.14286C11.7829 1.14286 14.8571 4.21714 14.8571 8C14.8571 11.7829 11.7829 14.8571 8 14.8571ZM8 0C3.58857 0 0 3.58857 0 8C0 12.4114 3.58857 16 8 16C12.4114 16 16 12.4114 16 8C16 3.58857 12.4114 0 8 0ZM10.9143 8.46858C10.5257 8.80572 7.10857 10.6743 6.56 10.8457C6.09714 11 5.90857 10.7371 5.84 10.6286C5.76 10.4686 5.72 10.2971 5.72 10.12V5.88C5.72 5.70857 5.76571 5.53143 5.84 5.37143C5.90857 5.25714 6.09714 5.00571 6.56 5.14857C7.10857 5.32571 10.5257 7.18857 10.9143 7.52571C11.0743 7.66286 11.1486 7.81143 11.1486 7.99429C11.1486 8.17715 11.0743 8.32571 10.9143 8.46286V8.46858ZM6.90857 4.06286C6.06857 3.79429 5.27429 4.08 4.84 4.81143C4.84 4.81143 4.84 4.82286 4.84 4.82857L4.82857 4.84C4.66286 5.16 4.57714 5.52 4.57714 5.88V10.12C4.57714 10.48 4.66286 10.84 4.82857 11.16C4.82857 11.1657 4.83429 11.1714 4.84 11.1771V11.1886C4.84 11.1886 4.88 11.24 4.89714 11.2686C4.89714 11.28 4.90857 11.2857 4.92 11.2971C5.24571 11.7714 5.73714 12.04 6.29143 12.04C6.49143 12.04 6.69714 12.0057 6.90286 11.9429C7.52571 11.7429 11.1086 9.81714 11.6571 9.33714C12.0686 8.98286 12.28 8.52 12.28 8.00571C12.28 7.49143 12.0629 7.02857 11.6571 6.67428C11.1086 6.19428 7.52571 4.26857 6.90286 4.06857H6.91429L6.90857 4.06286Z" fill="currentColor"/>
              </g>
              <defs>
                <clipPath id="clip0_40002161_2825">
                  <rect width="16" height="16" fill="white"/>
                </clipPath>
              </defs>
            </svg>
            Si, ver guía rápida
          </button>
          <button class="btn-skip" @click="skipToSite">
            <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M11.0373 0H8.99305V1.2H11.0373V0ZM13.9449 2.268C13.6272 0.917999 12.3982 0 11.0373 0V1.2C11.8706 1.2 12.596 1.758 12.7819 2.544L13.9509 2.268H13.9449ZM14.3945 7.2C14.3945 5.514 14.2926 3.714 13.9449 2.268L12.7759 2.544C13.0876 3.852 13.1895 5.538 13.1895 7.2H14.3885H14.3945ZM8.99305 0C8.66333 0 8.39355 0.27 8.39355 0.6C8.39355 0.93 8.66333 1.2 8.99305 1.2V0ZM13.1955 7.2C13.1955 7.53 13.4653 7.8 13.795 7.8C14.1247 7.8 14.3945 7.53 14.3945 7.2H13.1955Z" fill="currentColor"/>
              <path d="M11.0373 13.2H8.99305V14.4H11.0373V13.2ZM12.7819 11.856C12.596 12.642 11.8706 13.2 11.0373 13.2V14.4C12.3982 14.4 13.6272 13.482 13.9449 12.132L12.7759 11.856H12.7819ZM13.1955 7.20004C13.1955 8.86204 13.0936 10.542 12.7819 11.856L13.9509 12.132C14.2986 10.68 14.4005 8.88604 14.4005 7.20004H13.2015H13.1955ZM8.99305 13.2C8.66333 13.2 8.39355 13.47 8.39355 13.8C8.39355 14.13 8.66333 14.4 8.99305 14.4V13.2ZM14.3945 7.20004C14.3945 6.87004 14.1247 6.60004 13.795 6.60004C13.4653 6.60004 13.1955 6.87004 13.1955 7.20004H14.3945Z" fill="currentColor"/>
              <path d="M9.4843 6.34805L6.60072 3.44405L5.74944 4.29005L8.63302 7.19405L9.4843 6.34805ZM9.50229 8.00405C9.70611 7.78205 9.83201 7.50005 9.83201 7.18205C9.83201 6.86405 9.70012 6.58205 9.50229 6.36005L8.61503 7.16405L8.63901 7.19405C8.63901 7.19405 8.63901 7.18805 8.63901 7.18205V7.17005C8.63901 7.17005 8.63901 7.18205 8.61503 7.20005L9.50229 8.00405ZM6.6247 10.9441L9.4903 8.02205L8.63302 7.18205L5.76742 10.1041L6.6247 10.9441ZM6.60072 3.44405C6.36692 3.21005 5.98923 3.21005 5.75543 3.44405C5.52163 3.67805 5.52163 4.05605 5.75543 4.29005L6.60672 3.44405H6.60072ZM9.05866 6.76805L9.50229 6.36605L9.4903 6.35405L9.47831 6.34205L9.05266 6.76805H9.05866ZM9.05866 7.60205L9.4843 8.02205H9.4903L9.49629 8.00405L9.05266 7.60205H9.05866ZM5.76742 10.1041C5.53362 10.3381 5.53961 10.7221 5.77342 10.9501C6.00722 11.1841 6.3909 11.1781 6.61871 10.9441L5.76143 10.1041H5.76742Z" fill="currentColor"/>
              <path d="M9.23225 6.61206H0.599497V7.81206H9.23225V6.61206ZM0.599497 6.61206C0.269774 6.61206 0 6.88206 0 7.21206C0 7.54206 0.269774 7.81206 0.599497 7.81206V6.61206ZM9.23225 7.81206C9.56197 7.81206 9.83175 7.54206 9.83175 7.21206C9.83175 6.88206 9.56197 6.61206 9.23225 6.61206V7.81206Z" fill="currentColor"/>
            </svg>
            No, ir al sitio
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
let modalImage = null

try {
  modalImage = require('@/assets/images/imagen3.jpg')
} catch (e) {
  // Imagen del modal no encontrada
}

export default {
  name: 'WelcomeModal',
  data() {
    return {
      showModal: false,
      isMobile: false,
      modalImage: modalImage,
      floatingBtnTop: 0,
      heroWidgetBottom: 0,
      maxModalHeight: 0,
      paddingBottom: 0
    }
  },
  mounted() {
    this.checkMobile()
    this.calculateFloatingBtnPosition()
    window.addEventListener('resize', this.checkMobile)
    window.addEventListener('resize', this.calculateFloatingBtnPosition)
    window.addEventListener('scroll', this.calculateFloatingBtnPosition)
    
    // Mostrar el modal siempre en móvil al cargar/refrescar la página
    if (this.isMobile) {
      setTimeout(() => {
        this.showModal = true
        this.calculateFloatingBtnPosition()
        document.body.style.overflow = 'hidden'
      }, 500)
    }
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.checkMobile)
    window.removeEventListener('resize', this.calculateFloatingBtnPosition)
    window.removeEventListener('scroll', this.calculateFloatingBtnPosition)
    // Restaurar scroll del body
    document.body.style.overflow = ''
  },
  watch: {
    showModal(newVal) {
      // Bloquear/desbloquear scroll del body según el estado del modal
      if (newVal) {
        document.body.style.overflow = 'hidden'
      } else {
        document.body.style.overflow = ''
      }
    }
  },
  methods: {
    calculateFloatingBtnPosition() {
      // Buscar el botón flotante en el DOM
      const floatingBtn = document.querySelector('.floating-btn')
      if (floatingBtn) {
        // Obtener la posición del botón desde el top del viewport
        const btnRect = floatingBtn.getBoundingClientRect()
        // Usar la posición top del botón para que el modal empiece desde arriba alineado con él
        this.floatingBtnTop = btnRect.top
      } else {
        // Fallback: posición aproximada del botón en móvil (12% del viewport)
        const viewportHeight = window.innerHeight
        this.floatingBtnTop = viewportHeight * 0.12
      }
      
      // Calcular la posición del hero-widget para limitar la altura del modal
      const heroWidget = document.querySelector('.hero-widget')
      if (heroWidget) {
        const widgetRect = heroWidget.getBoundingClientRect()
        // Obtener la posición bottom del widget
        this.heroWidgetBottom = widgetRect.bottom
        // Agregar un margen adicional para que el modal sea más largo
        const extraMargin = 35
        // Calcular la altura máxima del modal (desde el top del botón hasta el bottom del widget + margen)
        this.maxModalHeight = this.heroWidgetBottom - this.floatingBtnTop + extraMargin
        // Calcular el padding-bottom para que el modal cubra hasta el final del viewport
        // En resoluciones pequeñas (como 687px), asegurar que cubra toda la parte inferior
        const viewportHeight = window.innerHeight
        const availableSpace = viewportHeight - this.heroWidgetBottom
        // Si hay poco espacio disponible, extender el padding para cubrir completamente
        if (viewportHeight <= 687) {
          this.paddingBottom = Math.max(availableSpace - extraMargin, 0)
        } else {
          this.paddingBottom = window.innerHeight - this.heroWidgetBottom - extraMargin
        }
      } else {
        // Fallback: altura máxima aproximada
        this.maxModalHeight = window.innerHeight - this.floatingBtnTop - 40
        this.paddingBottom = 40
      }
    },
    checkMobile() {
      this.isMobile = window.innerWidth <= 768
      // Si cambia a desktop, ocultar el modal
      if (!this.isMobile) {
        this.showModal = false
        document.body.style.overflow = ''
      }
      // Recalcular posición del botón cuando cambia el tamaño
      this.calculateFloatingBtnPosition()
    },
    closeModal() {
      this.showModal = false
      document.body.style.overflow = ''
    },
    showGuide() {
      this.closeModal()
      window.dispatchEvent(new CustomEvent('open-video-guide'))
    },
    skipToSite() {
      this.closeModal()
    }
  }
}
</script>

<style scoped>
.welcome-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: flex-start;
  justify-content: center;
  z-index: 10000;
  padding: 0;
  min-height: 100vh;
  min-height: 100dvh; /* Para navegadores que soportan dvh */
}

.welcome-modal {
  background: var(--white);
  border-radius: 8px;
  width: 100%;
  max-width: 500px;
  overflow-y: auto;
  overflow-x: hidden;
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
  animation: slideUp 0.3s ease-out;
  margin: 0 auto;
}


@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.modal-image-container {
  position: relative;
  width: calc(100% - 24px);
  height: 150px;
  overflow: hidden;
  background-color: #182844A6;
  margin: 12px;
  border-radius: 8px;
  border: 2px solid var(--white);
}

.modal-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  mix-blend-mode: overlay;
}

.modal-image-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
  display: flex;
  align-items: flex-end;
  justify-content: flex-start;
  overflow: hidden;
  padding: 20px;
  padding-bottom: 15px;
  padding-left: 0px;
}

.modal-image-overlay svg {
  width: auto;
  height: auto;
  max-width: 100%;
  opacity: 1;
}

.modal-content {
  padding: 20px 20px 12px 20px;
}

.modal-title {
  font-size: 20px;
  font-weight: bold;
  color: #024588;
  margin-bottom: 16px;
  line-height: 1.3;
  text-align: center;
}

.modal-question {
  font-size: 16px;
  color: #6B7280;
  margin-bottom: 18px;
  text-align: center;
}

.modal-buttons {
  display: flex;
  flex-direction: row;
  gap: 10px;
}

.btn-guide {
  flex: 1;
  padding: 14px 12px;
  background: #D7E5F4;
  color: #024588;
  border: none;
  border-radius: 8px;
  font-family: 'Ubuntu', sans-serif;
  font-size: 12px;
  font-weight: 700;
  font-style: normal;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-width: 0;
  transition: all 0.3s ease;
}

.btn-guide:hover {
  background: var(--secondary-blue);
  color: var(--white);
}

.btn-guide svg {
  flex-shrink: 0;
}

.btn-skip {
  flex: 1;
  padding: 14px 12px;
  background: var(--white);
  color: #024588;
  border: 2px solid var(--primary-blue);
  border-radius: 8px;
  font-family: 'Ubuntu', sans-serif;
  font-size: 12px;
  font-weight: 700;
  font-style: normal;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-width: 0;
  transition: all 0.3s ease;
}

.btn-skip:hover {
  background: var(--primary-blue);
  color: var(--white);
}

.btn-skip svg {
  flex-shrink: 0;
}

/* Solo mostrar en móvil */
@media (min-width: 769px) {
  .welcome-modal-overlay {
    display: none;
  }
}

@media (max-width: 768px) {
  .welcome-modal-overlay {
    padding-left: 20px;
    padding-right: 20px;
    align-items: flex-start;
    justify-content: center;
  }
  
  .welcome-modal {
    margin-top: -4px;
    width: 100%;
    max-width: 500px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    background: #F8F8F8;
  }
}

/* Ajustes específicos para resoluciones pequeñas como 687px */
@media (max-width: 687px) {
  .welcome-modal-overlay {
    align-items: stretch;
    padding-bottom: 0;
    min-height: 100vh;
    min-height: 100dvh;
  }
  
  .welcome-modal {
    margin-bottom: 0;
    flex: 1;
    display: flex;
    flex-direction: column;
    min-height: 0;
    max-height: none !important;
  }
}

@media (max-width: 480px) {
  .modal-content {
    padding: 5px 20px 12px 20px;
  }
}

</style>
